import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { pdf } from '@react-pdf/renderer';
import { useDispatch } from 'react-redux';
import { CSVLink } from 'react-csv';
import PropTypes from 'prop-types';

import { productReportDetailsGet } from '../../../store/slices/tenantSlices/productSlice';
import ManualOrderPDF from '../../../components/ManualOrderPDF';

const ProductReportDetails = ({ isOpen, onCloseClick, infoDetails }) => {
  const dispatch = useDispatch();
  const excelRef = useRef();

  const [productDetails, setProductDetails] = useState(null);
  const [productDetailsList, setProductDetailsList] = useState([]);

  const fetchProductReportDetails = async () => {
    try {
      const response = await dispatch(productReportDetailsGet(infoDetails?.id)).unwrap();
      setProductDetails(response?.product_report?.[0]);
      setProductDetailsList(response?.product_report_details);
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchProductReportDetails();
    }
  }, [isOpen]);

  const onExportClick = async () => {
    const pdfData = { ...productDetails, product_details: [...productDetailsList] };
    const pdfBlob = await pdf(<ManualOrderPDF data={pdfData} />).toBlob();
    const link = document.createElement('a');
    link.href = URL.createObjectURL(pdfBlob);
    link.download = 'manual_order.pdf';
    link.click();
    onCloseClick();
  };

  const csvHeaderFields = [
    { label: 'Name', key: 'product_name' },
    { label: 'UOM', key: 'uom' },
    { label: 'Rate', key: 'rate' },
    { label: 'Quantity', key: 'quantity' },
    { label: 'Total', key: 'total_amount' }
  ];

  const csvDetails = {
    headers: csvHeaderFields,
    data: productDetailsList,
    filename: 'product_report.csv'
  };

  return (
    <Modal isOpen={isOpen} size="xl" centered>
      <ModalHeader className="justify-content-center py-2">
        <div className="fs-5">Product Report Details</div>
      </ModalHeader>
      <ModalBody className="px-4">
        <Row className="mb-3 px-2">
          <Col lg="3" md="3" className="d-flex flex-row align-items-center gap-2">
            <label className="text-dark fw-bolder">User:</label>
            <label>{productDetails?.username}</label>
          </Col>
          <Col lg="3" md="3" className="d-flex flex-row align-items-center gap-2">
            <label className="text-dark fw-bolder">Area:</label>
            <label>{productDetails?.area}</label>
          </Col>
          <Col lg="3" md="3" className="d-flex flex-row align-items-center gap-2">
            <label className="text-dark fw-bolder">Beat:</label>
            <label>{productDetails?.beat}</label>
          </Col>
          <Col lg="3" md="3" className="d-flex flex-row align-items-center gap-2">
            <label className="text-dark fw-bolder">Outlet:</label>
            <label>{productDetails?.outlet}</label>
          </Col>
        </Row>
        {productDetailsList?.length > 0 ? (
          <React.Fragment>
            <div className="daily-report-table" style={{ height: 'calc(100vh - 310px)' }}>
              <table className="report-list-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>UOM</th>
                    <th className="text-center" style={{ width: '120px' }}>
                      Rate
                    </th>
                    <th className="text-center" style={{ width: '120px' }}>
                      Quantity
                    </th>
                    <th className="text-center" style={{ width: '120px' }}>
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {productDetailsList?.map((val, index) => {
                    return (
                      <tr key={index}>
                        <td>{val?.product_name}</td>
                        <td>{val?.uom}</td>
                        <td className="text-end">{val?.rate}</td>
                        <td className="text-end">{val?.quantity}</td>
                        <td className="text-end">{val?.total_amount}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <Row className="py-2 align-items-center">
              <Col lg="6" md="6">
                <label className="text-info fw-bolder fs-5">Total Amount :&nbsp;</label>
                <label className="text-dark fw-bolder fs-5">
                  {productDetails?.total_amount}
                </label>
              </Col>
              <Col lg="6" md="6">
                <label className="text-info fw-bolder fs-5">Total Quantity :&nbsp;</label>
                <label className="text-dark fw-bolder fs-5">
                  {productDetails?.total_quantity}
                </label>
              </Col>
            </Row>
          </React.Fragment>
        ) : null}
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            onCloseClick();
          }}
          className="px-5 bg-transparent text-primary">
          Cancel
        </Button>
        <CSVLink {...csvDetails} ref={excelRef}>
          <Button className="px-5 bg-primary border-primary">Export CSV</Button>
        </CSVLink>
        <Button className="px-5 bg-primary border-primary" onClick={() => onExportClick()}>
          Export PDF
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ProductReportDetails.propTypes = {
  isOpen: PropTypes.bool,
  onCloseClick: PropTypes.func,
  infoDetails: PropTypes.object
};

export default ProductReportDetails;
